import { render, staticRenderFns } from "./InventoryImportPod.vue?vue&type=template&id=da8b98e0&scoped=true"
import script from "./InventoryImportPod.vue?vue&type=script&lang=js"
export * from "./InventoryImportPod.vue?vue&type=script&lang=js"
import "./InventoryImportPod.vue?vue&type=style&index=0&id=da8b98e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8b98e0",
  null
  
)

export default component.exports